import { loadableWithFallback } from '@vision/ui/utils';
import type { TrendChart3Props } from './TrendChart3';

export const TrendChart3 = loadableWithFallback<TrendChart3Props>(() => import('./TrendChart3'));
